import {useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';
import {selectedPresentationSelector} from '../../store/selectors/presentation.selectors';
import {createSocketConnection, socket} from '../socket';
import {
    addEmittedSlideAction,
    copyEmittedSlideAction,
    importEmittedSlideAction,
    removeEmittedSlideAction,
    swapEmittedSlideAction,
    updateEmittedSlideAction,
    updateEmittedSlidePreviewAction,
} from '../../store/actions/slide';
import {
    deleteEmittedSharedPresentationAction,
    updatePresentationWithEmittedPresentationAction,
    updateSharedPresentationWithEmittedSharedPresentationAction,
} from '../../store/actions/presentation';

export function usePresentationSocket(): void {
    const dispatch = useDispatch();

    const {_id} = useSelector(selectedPresentationSelector);

    useEffect(() => {
        if (_id) {
            createSocketConnection({presentationId: _id});

            if (socket) {
                socket.connect();

                socket.on('slide_add', (data) => {
                    if (data.slides && data.slideIndexList) {
                        dispatch(addEmittedSlideAction(data.slides, data.slideIndexList));
                    }
                });

                socket.on('slide_removed', (data) => {
                    if (data.slideId) {
                        dispatch(removeEmittedSlideAction(data.slideId));
                    }
                });

                socket.on('slide_copied', (data) => {
                    if (data.slide && data.slideId) {
                        dispatch(copyEmittedSlideAction(data.slideId, data.slide));
                    }
                });

                socket.on('slide_update', (data) => {
                    if (data.slide) {
                        dispatch(updateEmittedSlideAction(data.slide));
                    }
                });

                socket.on('slide_preview_update', (data) => {
                    if (data.slidePreview) {
                        dispatch(updateEmittedSlidePreviewAction(data.slidePreview));
                    }
                });

                socket.on('slide_swap', (data) => {
                    if (data.slideIndexList) {
                        dispatch(swapEmittedSlideAction(data.slideIndexList));
                    }
                });

                socket.on('slide_import', (data) => {
                    if (data.slides) {
                        dispatch(importEmittedSlideAction(data.slides, data.presentation));
                    }
                });

                socket.on('presentation_updated', (data) => {
                    if (data.presentation) {
                        dispatch(updatePresentationWithEmittedPresentationAction({presentation: data.presentation}));
                    }
                });

                socket.on('player_label_updated', (data) => {
                    if (data.labels) {
                        dispatch(updatePresentationWithEmittedPresentationAction({labels: data.labels}));
                    }
                });

                socket.on('presentation_protection_updated', (data) => {
                    if (data.protection) {
                        dispatch(updatePresentationWithEmittedPresentationAction({protection: data.protection}));
                    }
                });

                socket.on('presentation_share_update', (data) => {
                    if (data.sharedPresentation) {
                        dispatch(updateSharedPresentationWithEmittedSharedPresentationAction(data.sharedPresentation));
                    }
                });

                socket.on('shared_presentation_delete', (data) => {
                    if (data.presentationIds) {
                        dispatch(deleteEmittedSharedPresentationAction(data.presentationIds));
                    }
                });
            }
        }

        return () => {
            if (socket) {
                socket.disconnect();
                socket.removeAllListeners();
            }
        };
    }, [dispatch, _id]);
}
